export const IDP_USERS_PRODUCTION = 'IDP Users Production';
export const UDL_HUB_SERVICE_PRINCIPALS = 'udl_hub_service_principals';
export const SEARCH_DEBOUNCE_TIME_MILLIS = 500;